// extracted by mini-css-extract-plugin
export default {"errorContainer":"index__errorContainer___uYnlx","errorTitle":"index__errorTitle___1gsBU","errorContent":"index__errorContent___3sOM-","goToHomeBtn":"index__goToHomeBtn___3WCg7"};